export default "__VITE_ASSET__Cw16nyQM__"